// @flow

import _ from 'lodash';

import type { Error } from 'error';

// use Response <T>
type ItemsResponse<T> = {
	Items: T[],
	Total: number,
}

type NormalizedItemsResponse<T> = {
	items: T[],
	total: number
}

export interface DataResponse<T> {
	Data: T;
	Error: string,
	Status: boolean,
}

export interface StatusResponse {
	Status: string,
	StatusText: string,
}

export type Response<T> = DataResponse<ItemsResponse<T>>;
export type NormalizedResponse<T> = DataResponse<NormalizedItemsResponse<T>>;

type Data<T> = $PropertyType<T, 'Data'>;
type Items<T> = $PropertyType<T, 'Items'>;

export default class RequestResult<T> {
	_result: T;
	_error: ?Error;

	get items (): Items<Data<T>> {
		return _.get(this.data, 'Items') || _.get(this.data, 'items');
	}

	get data (): Data<T> {
		return _.get(this._result, 'Data');
	}

	get result (): T {
		return this._result;
	}

	constructor (result: T, err: Error) {
		this._result = result;
		this._error = err;
	}
}
